import React, { useEffect, useState, useRef } from "react";

import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { useHistory, withRouter } from 'react-router-dom';

import { cloneDeep } from "lodash";
import { Helpers, ChipSelect } from "dsilo-ui-components";

import { Box, Button, CircularProgress, Divider, Grid, IconButton, InputLabel, makeStyles, TextField, Typography, Paper } from "@material-ui/core";

import { Cancel, Info } from "@material-ui/icons";
import DeleteIcon from '@material-ui/icons/Delete';
import GetAppIcon from '@material-ui/icons/GetApp';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import AddIcon from '@material-ui/icons/Add';

import { Loader } from "../loader";
import ShowFileUploadModel from './model'
import { hasAbility, fetchPrivilegeSupport, canAny, SystemOperations, validateAccessControlResponse, isViewOnly } from '../../utility/AbilityCheck'; // Import ability function
import { MIN_LENGTH_FOR_STRING_FIELDS, MAX_LENGTH_FOR_STRING_FIELDS, MIN_LENGTH_FOR_TEXT_AREA_FIELDS, MAX_LENGTH_FOR_TEXT_AREA_FIELDS } from '../../constants';

import { getDataModelById, getContractDataById, updateDataModelData, createDocument, clearReduxDataOfCurrentComponent, getModelData, uploadAttachmentAmendmentTemplate, downloadAmendmentTemplateAction, downloadAmendmentTemplateActionV2, downloadContractPDFAction, createObligationsDocument} from '../../store/actions';

const useStyles = makeStyles((theme) => {
  const isNewV1Theme = theme?.isNewV1Theme || false;

return {
	tabController: {
		"& .MuiTab-textColorInherit ": {
			minWidth: "0px"
		}
	},
	appBar: {
		boxShadow: "none !important"
	},
	ContactTabs: {
		marginTop: 'none !important',
		marginBottom: 'none !important',
		border: "3px solid #eeee",
	},
	paper: {
		width: '100%',
		border: "3px solid #eeee",
		marginLeft: '-41px !important'
	},
	backIconCls: {
		padding: '0px !important',
		...(isNewV1Theme ? {border: "1px solid #E9EBF5", borderRadius: "4px",} : {}),
	},
	InputLabel: {
		marginTop: 0
	},
	TextField: {
		width: '100%',
		'& .MuiInputBase-formControl': {
			height: '43px !important'
		}
	},
	gridStyle1: { display: 'flex', gap: '10px', justifyContent: 'center', alignItems: 'center' },
	gridStyle2: { display: 'flex', gap: '5px' },
	divContainer:{position: 'absolute', width: "100%"},
	divHeader:{...(isNewV1Theme ? {display: 'flex', paddingBottom: 16} :{padding: "10px 20px 10px 0px", display: 'flex', justifyContent: 'space-between' }),},
	gridContainer:{
		...(isNewV1Theme ? {position: 'relative', overflow: 'visible',margin: 0, width: '100%', padding: 16} :{padding: "20px 5px 0px 0px", position: 'relative', overflow: 'visible'}),
	},
	buttonContainer:{
		borderTop: '1px solid #E0E0E0', 
		padding: 10,
		display: 'flex',
		justifyContent: 'end',
		alignItems: 'center',
		gap: 10
	},
	update:{
        borderRadius: "4px",
        border: "1px solid #3F51B5",
        background: "#3F51B5",
        color: '#fff',
        textTransform: 'capitalize',
        height: '30px',
        boxSizing: 'border-box',
        boxShadow: 'none',
        "&:hover": {
            background: "#303F9F",
            color: "#fff",
            boxShadow: 'none',
        },
    },
    cancel:{
       borderRadius: "4px", 
       border: "1px solid #3F51B5",
       color: '#3F51B5',
       background: "#fff",
       textTransform: 'capitalize',
       height: '30px',
       boxSizing: 'border-box',
       boxShadow: 'none',
       "&:hover": {
        boxShadow: 'none',       
       },
    },
	newDesignHeader: {
		display: 'flex',
		alignItems: 'center',
		paddingBottom: '16px',
		gap: '10px',
	},
	newDesignContent: {
		padding: '16px',
		display: 'flex',
		flexDirection: 'column',
		borderRadius: '4px',
		maxHeight: 'calc(100vh - 230px)',
		overflow: 'auto',
		gap: 6,
	},
	newDesignRow: {
		display: 'flex',
		gap: '10px',
		width: '100%',
	},
	newDesignLeftColumn: {
		flex: 1,
	},
	newDesignRightColumn: {
		flex: 1,
	},
	lables: {
        color: '#78798E',
        fontSize: '12px',
        lineHeight: '17px',
        marginBottom: '6px important'
	},
    textField: {
          '& .MuiOutlinedInput-input': {
          padding: '14px !important',
          fontSize: '12px',
          },
          '& .MuiOutlinedInput-notchedOutline': {
          borderColor: '#D5D6DD !important',  
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: '#303F9F !important',
          },

          '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: '#3F51B5 !important',
          },
    },
	  chipSelect: {
        '& input': {
            height: 27,
        },
		'& div[class^="ChipSelect-valueContainer"]': {
			padding: '8px !important',  
			gap: 2,
		}, 
		'& .MuiChip-root': { 
			backgroundColor: '#fff !important',
			border: '1px solid #D5D6DD !important',     
		},   
		'& .MuiOutlinedInput-notchedOutline': {
			borderColor: '#D5D6DD !important',  
		},
		'&:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: '#303F9F !important',
		},
		'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: '#3F51B5 !important',
		},   
    },
	alternateVendorRow: {
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
		marginBottom: '12px',
		'&:last-child': {
			marginBottom: 0,
		},
	},
	addButton: {
		marginTop: '8px',
		textTransform: 'capitalize',
		color: '#3F51B5',
		borderColor: '#3F51B5',
		'&:hover': {
			borderColor: '#303F9F',
			backgroundColor: 'rgba(63, 81, 181, 0.04)',
		},
	},
	deleteIcon: {
		color: '#f44336',
		cursor: 'pointer',
		'&:hover': {
			color: '#d32f2f',
		},
	},
	uploadBox: {
		border: '1px dashed #3F51B5',
		borderRadius: '4px',
		padding: '12px 10px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		gap: '6px',
		cursor: 'pointer',
		backgroundColor: '#fff',
		'&:hover': {
			backgroundColor: 'rgba(63, 81, 181, 0.04)',
		},
	},
	uploadIcon: {
		fontSize: '16px',
	},
	uploadText: {
		color: '#3F51B5',
		fontWeight: 500,
		fontSize: '12px',
	},
	uploadedFileContainer: {
		display: 'flex',
	},
	uploadedFileBox: {
		display: 'flex',
		alignItems: 'center',
		border: '1px solid #D5D6DD',
		padding: '6px 12px',
		borderRadius: '4px',
		width: '100%',
		gap: 8,
	},
	uploadedFileName: {
		fontSize: '14px',
	},

}});

const dataElementTypes = ['array(string)', 'array(number)', 'array(currency)', 'array(date)'];

const SimpleForm = (props) => {
	const classes = useStyles();
	let history = useHistory();
    const {isNewV1Theme} = props;
	const { chartUniqueId, chartData } = props.data
	let _id = props.match.params.id // id is there then it is a edit mode
	const { CREATE, VIEW, DELETE, SEARCH, DOWNLOAD, EDIT, ALL } = SystemOperations;

	const [state, setState] = useState({})
	const [allDataElementsObj, setAllDataElementsObj] = useState({})
	const [selectedDataElements, setSelectedDataElements] = useState(chartData?.selectedDataElement || [])

	const [selectedFile, setSelectedFile] = useState(null);
	const [quickPdfView, setQuickPdfView] = useState(false)
	const [fileURL, setFileURL] = useState(null);
	const [file, setFile] = useState(null);
	const [htmlContent, setHtmlContent] = useState('');
	const [userHasAbility, setUserHasAbility] = useState(false);
	const [isAccessControl, setIsAccessControl] = useState({
		error: false,
		message: "",
		code: ""
	});
	const [idCount, setIdCount] = useState([]);
	const [uploadedFileRemoved, setUploadedFileRemoved] = useState(false);
	const [arrayFields, setArrayFields] = useState([]);
	const [regularFieldPairs, setRegularFieldPairs] = useState([]);
	const [validationErrors, setValidationErrors] = useState({});

	const handlesQuickPDFClose = () => {
		setQuickPdfView(false)
	}
	const handlesQuickPDFOpen = () => {
		setQuickPdfView(true)
	}
	const [previlageData, setPrevilageData] = useState("")

	// Generate abilities based on privileges
	const [ability, setAbility] = useState(null);

	// const ability = defineAbilities(privileges, selectedDataModelID);

	// Member Privileges code end here
	useEffect(() => {
		const { privilegeData, ability } = fetchPrivilegeSupport(props, chartData);
		setPrevilageData(privilegeData);
		setAbility(ability);
	}, [
		props.formData.document[`${props.match.params.appid}_memberprivileges`],
		props?.privilegesSupport,
		props.match.params.page,
		window.location.pathname,
		chartData?.selectedDataModel
	]);
	// Member Privileges code end here

	useEffect(() => {
		const checkAbility = hasAbility(ability);
		setUserHasAbility(checkAbility);
	}, [ability]);

	const formStateRef = useRef(idCount);
	useEffect(() => {
		//Fetch dataModel
		if (!props.formData?.dataModel?.[chartData.selectedDataModel]) {
			let payload = {
				appid: props.match.params.appid,
				orgId: props.appConfig?.org?._id,
				dataModelId: chartData.selectedDataModel,
				dataUniqueId: `${chartData.selectedDataModel}`
			}
			props.getDataModelById(payload)
		} else {

		}

		let fields = '';
		if (selectedDataElements?.length) {
			let isUpdated = false;
			let obj = {};
			selectedDataElements.map(sd => {
				fields += sd.value + ','
				if (sd.defaultValue) {
					obj[sd.value] = sd.defaultValue;
					isUpdated = true;
				}
			})
			if (isUpdated) {
				setState({ ...state, ...obj })
			}
		}

		if (_id) {
			let payload = {
				id: _id,
				dataModelId: chartData.selectedDataModel,
				appId: props.match.params.appid,
				// fields: selectedDataElements.map(i => i.value).join(","),
				fields: fields,
				dataUniqueId: chartUniqueId + '_get'
			}
			props.getContractDataById(payload)
		}
	}, [])

	useEffect(() => {
		return () => {
			clearCurrentChartReduxStore()
		}
	}, [])

	useEffect(() => {
		if (props.formData?.dataModel[chartData.selectedDataModel]?.dataElements) {
			let commonMasterDataConfiguredDataElements = props.formData?.dataModel[chartData.selectedDataModel]?.commonMasterDataConfiguration || []

			let dataElements = props.formData?.dataModel[chartData.selectedDataModel]?.dataElements || []
			let obj = {}
			dataElements.forEach((de) => obj[de.name] = de)
			setAllDataElementsObj(obj)

			let sldes = selectedDataElements.map((slde) => {
				let matchedDe = obj[slde.value];
				if (matchedDe) {
					if (matchedDe?.data?.type === "commonMasterDataConfiguration") {
						commonMasterDataConfiguredDataElements.forEach((derco) => {
							if (matchedDe?.data?.commonMasterDataConfigurationId === derco["_id"]) {
								setIdCount((prev) => {
									let resval = prev;
									resval = [...resval, `${derco["_id"]}`]
									formStateRef.current = resval;
									return resval
								})
								let payload = {
									appId: props.match.params.appid,
									id: derco.dataModel,
								};
								props.getModelData({ ...payload, dataUniqueId: `${derco["_id"]}` });
							}
						})
					}
					return {
						...slde,
						...matchedDe
					}
				} else {
					return slde
				}
			})
			setSelectedDataElements(sldes)
		}
	}, [props.formData?.dataModel[chartData.selectedDataModel]])

	const clearCurrentChartReduxStore = () => {
		let subKeys = [
			chartUniqueId + '_get',
			chartUniqueId + '_save',
			chartUniqueId + '_update',
			// chartUniqueId + '_dataElements',
			chartUniqueId + '_upload_Amendment_Template',
		]

		formStateRef.current.map((res) => {
			if (!subKeys.includes(res)) {
				subKeys.push(res)
			}
		})

		props.clearReduxDataOfCurrentComponent({
			key: "document",
			subKey: subKeys
		})
	}

	useEffect(() => {
		let res = props.formData.document[chartUniqueId + '_get'];
		if (res?.data?.[0]) {
			let news = res?.data?.[0] || {}
			setState({ ...state, ...news })
		}
		else if (res && res.errorInfo) {
			validateAccessControlResponse(res.errorInfo, setIsAccessControl)
			// setNoData(true)
			// setErrorMsg(document?.[chartUniqueId + "data"]?.message)
		}
	}, [props.formData.document[chartUniqueId + '_get']])

	useEffect(() => {
		let res = props.formData.document[chartUniqueId + '_save'];
		if (res && !selectedFile) {
			toast.success(res.message || 'Document Created Successfully')
			handleBackBtnClick()
		}
		if (res && selectedFile) {
			Object?.entries(selectedFile)?.forEach(([key, file]) => {
				if (file) {
					const payload = payloadForUploadSupportingDocument(file, key, res?.data[0]["_id"], chartData.selectedDataModel);
					props.uploadAttachmentAmendmentTemplate(payload);
				}
			});
		}

		// if (res && selectedFile) {
		//     props.uploadAttachmentAmendmentTemplate(payloadForUploadSupportingDocument(selectedFile, res[0]["_id"], chartData.selectedDataModel))
		// }
	}, [props.formData?.document?.[chartUniqueId + '_save']])

	useEffect(() => {
		let res = props.formData.document[chartUniqueId + '_upload_Amendment_Template'];
		if (res) {
			if (!_id) {
				toast.success(res.message || 'Document Created Successfully')
			}
			handleBackBtnClick()

		}
	}, [props.formData?.document?.[chartUniqueId + '_upload_Amendment_Template']])

	useEffect(() => {
		let res = props.formData.document[chartUniqueId + '_update'];
		if (res && !selectedFile) {
			handleBackBtnClick()
		}
		if (res && selectedFile) {
			Object?.entries(selectedFile)?.forEach(([key, file]) => {
				if (file) {
					const payload = payloadForUploadSupportingDocument(file, key, _id, chartData.selectedDataModel);
					props.uploadAttachmentAmendmentTemplate(payload);
				}
			});
		}
		// if (res && selectedFile) {
		//     props.uploadAttachmentAmendmentTemplate(payloadForUploadSupportingDocument(selectedFile, _id, chartData.selectedDataModel))
		// }
	}, [props.formData?.document?.[chartUniqueId + '_update']])

	useEffect(() => {
		// Filter fields (skip first 2 fields: name, description, and exclude select/file fields which are handled in Row 2)
		const filteredFields = selectedDataElements.filter(item => {
			if (item?.hide) return false
			const index = selectedDataElements.filter(i => !i?.hide).indexOf(item)
			if (index < 2) return false // Skip first 2 fields (name, description)
			let de = allDataElementsObj[item.value]
			let type = de?.type || 'string'
			// Exclude select and file fields as they're already handled in Row 2
			if (type === 'select' || de?.data?.type === "custom" || type === "file") {
				return false
			}
			return true // Include all other field types
		})

		// Separate array types and regular fields (select and file are excluded)
		const arrayFields = []
		const regularFields = []

		filteredFields.forEach((item, index) => {
			let de = allDataElementsObj[item.value]
			let type = de?.type || 'string'
			const isArrayType = dataElementTypes.indexOf(type) !== -1

			if (isArrayType) {
				arrayFields.push({ item, index, type })
			} else {
				regularFields.push({ item, index, type })
			}
		})

		// Group regular fields into pairs
		const regularFieldPairs = []
		for (let i = 0; i < regularFields.length; i += 2) {
			regularFieldPairs.push(regularFields.slice(i, i + 2))
		}

		setArrayFields(arrayFields)
		setRegularFieldPairs(regularFieldPairs)
	}, [selectedDataElements, allDataElementsObj])

	const handleAddTextbox = (fieldName, fieldType) => {
		let _state = cloneDeep(state)
		let defaultValue = ["number", "currency"].includes(fieldType) ? 0 : ""
		if (!_state?.[fieldName]) {
			_state[fieldName] = [defaultValue]
		} else {
			_state[fieldName].push(defaultValue)
		}

		setState(_state)
	}

	const handleDeleteTextbox = (fieldName, fieldIndex) => {
		let _state = cloneDeep(state)
		_state[fieldName] = _state?.[fieldName]?.filter((item, i) => i !== fieldIndex)
		setState(_state)
	}

	const handlesQuickDownload = () => {
		props.downloadContractPDFAction({
			appid: props.appId,
			_id: props.match.params.id,
			payload: {},
			enableOtherAttachmentUpload: true,
			isNotAFile: true,
			dataModelId: chartData.selectedDataModel,
			dataUniqueId: "download_amendment_docx_file"
		});
	}

	const onChangeField = (key, value, fieldType = '', fieldIndex = 0) => {
		let _state = cloneDeep(state)
		if (fieldType && dataElementTypes.indexOf(fieldType) !== -1) {
			let isNumber = ["array(number)", "array(currency)"].includes(fieldType);
			let newValue = isNumber ? parseInt(value) : value;
			if (!_state?.[key]) {
				_state[key] = [newValue]
			} else {
				_state[key][fieldIndex] = newValue
			}
		} else {
			_state[key] = value;
		}
		console.log('_state ::: *** ', _state)
		setState(_state)

		// Clear validation error for this field when user types
		if (validationErrors[key]) {
			setValidationErrors(prev => {
				const newErrors = { ...prev };
				delete newErrors[key];
				return newErrors;
			});
		}
	}

	// Validation function to check regex patterns
	const validateField = (fieldValue, regexPattern) => {
		if (!regexPattern) return true; // No regex means no validation needed

		try {
			// Remove leading and trailing slashes from regex string
			const cleanPattern = regexPattern.replace(/^\/|\/$/g, '');
			const regex = new RegExp(cleanPattern);

			// Convert value to string for validation
			const stringValue = fieldValue !== null && fieldValue !== undefined ? String(fieldValue) : '';
			return regex.test(stringValue);
		} catch (error) {
			console.error('Invalid regex pattern:', regexPattern, error);
			return true; // If regex is invalid, don't block submission
		}
	}

	// Helper function to check if a value is empty
	const isEmpty = (value) => {
		if (value === null || value === undefined) return true;
		if (typeof value === 'string' && value.trim() === '') return true;
		if (Array.isArray(value) && value.length === 0) return true;
		if (Array.isArray(value) && value.every(v => v === null || v === undefined || (typeof v === 'string' && v.trim() === ''))) return true;
		return false;
	}

	// Helper function to get effective min/max length for a field
	const getEffectiveLength = (item, type) => {
		let minLength = null;
		let maxLength = null;

		if (type === 'string') {
			// For string fields
			if (item.minLength !== null && item.minLength !== undefined) {
				minLength = Math.max(item.minLength, MIN_LENGTH_FOR_STRING_FIELDS);
			} else {
				minLength = MIN_LENGTH_FOR_STRING_FIELDS;
			}

			if (item.maxLength !== null && item.maxLength !== undefined) {
				maxLength = Math.min(item.maxLength, MAX_LENGTH_FOR_STRING_FIELDS);
			} else {
				maxLength = MAX_LENGTH_FOR_STRING_FIELDS;
			}
		} else if (type === 'textarea') {
			// For textarea fields
			if (item.minLength !== null && item.minLength !== undefined) {
				minLength = Math.max(item.minLength, MIN_LENGTH_FOR_TEXT_AREA_FIELDS);
			} else {
				minLength = MIN_LENGTH_FOR_TEXT_AREA_FIELDS;
			}

			if (item.maxLength !== null && item.maxLength !== undefined) {
				maxLength = Math.min(item.maxLength, MAX_LENGTH_FOR_TEXT_AREA_FIELDS);
			} else {
				maxLength = MAX_LENGTH_FOR_TEXT_AREA_FIELDS;
			}
		}

		return { minLength, maxLength };
	}

	// Helper function to validate field length
	const validateLength = (value, minLength, maxLength, fieldLabel) => {
		if (value === null || value === undefined || value === '') return null;

		const stringValue = String(value);
		const length = stringValue.length;

		if (minLength !== null && length < minLength) {
			return `${fieldLabel} must be at least ${minLength} characters`;
		}

		if (maxLength !== null && length > maxLength) {
			return `${fieldLabel} must be at most ${maxLength} characters`;
		}

		return null;
	}

	// Validate all fields
	const validateAllFields = () => {
		const errors = {};

		selectedDataElements.forEach(item => {
			if (item?.hide) return; // Skip hidden fields

			const fieldValue = state[item.value];
			const regexPattern = item.regex;
			const isRequired = item.required === true;
			let de = allDataElementsObj[item.value];
			let type = de?.type || item.type || 'string';

			// Check required fields first
			if (isRequired) {
				// Handle array fields
				if (dataElementTypes.indexOf(type) !== -1) {
					if (isEmpty(fieldValue)) {
						errors[item.value] = `${item.label} is required`;
					} else if (Array.isArray(fieldValue)) {
						// Check each array item
						fieldValue.forEach((val, index) => {
							if (val === null || val === undefined || (typeof val === 'string' && val.trim() === '')) {
								errors[`${item.value}_${index}`] = `${item.label} is required`;
							}
						});
					}
				}
				// Handle file fields
				else if (type === "file") {
					if (!fieldValue && !selectedFile?.[item.value]) {
						errors[item.value] = `${item.label} is required`;
					}
				}
				// Handle select fields
				else if (type === 'select' || de?.data?.type === "custom") {
					if (isEmpty(fieldValue)) {
						errors[item.value] = `${item.label} is required`;
					}
				}
				// Handle regular fields
				else {
					if (isEmpty(fieldValue)) {
						errors[item.value] = `${item.label} is required`;
					}
				}
			}

			// Validate length and regex pattern if field has a value and is not already marked as required error
			if (!errors[item.value] && !isEmpty(fieldValue)) {
				// Handle array fields
				if (dataElementTypes.indexOf(type) !== -1) {
					if (Array.isArray(fieldValue)) {
						fieldValue.forEach((val, index) => {
							const errorKey = `${item.value}_${index}`;
							// Only check if not already marked as required
							if (!errors[errorKey] && val !== null && val !== undefined && val !== '') {
								// Validate length for array items (assuming they are string type)
								const { minLength, maxLength } = getEffectiveLength(item, 'string');
								const lengthError = validateLength(val, minLength, maxLength, item.label);
								if (lengthError) {
									errors[errorKey] = lengthError;
								} else if (!validateField(val, regexPattern)) {
									errors[errorKey] = item.regexErrorMessage || `${item.label} is invalid`;
								}
							}
						});
					} else if (fieldValue !== null && fieldValue !== undefined && fieldValue !== '') {
						// Single value in array field
						const { minLength, maxLength } = getEffectiveLength(item, 'string');
						const lengthError = validateLength(fieldValue, minLength, maxLength, item.label);
						if (lengthError) {
							errors[item.value] = lengthError;
						} else if (!validateField(fieldValue, regexPattern)) {
							errors[item.value] = item.regexErrorMessage || `${item.label} is invalid`;
						}
					}
				} else if (type !== "file" && type !== 'select' && de?.data?.type !== "custom") {
					// Regular fields - validate length and regex if value exists
					// Check if it's a string or textarea field
					if (type === 'string' || type === 'textarea') {
						const { minLength, maxLength } = getEffectiveLength(item, type);
						const lengthError = validateLength(fieldValue, minLength, maxLength, item.label);
						if (lengthError) {
							errors[item.value] = lengthError;
						} else if (!validateField(fieldValue, regexPattern)) {
							errors[item.value] = item.regexErrorMessage || `${item.label} is invalid`;
						}
					} else {
						// For other field types, only validate regex
						if (!validateField(fieldValue, regexPattern)) {
							errors[item.value] = item.regexErrorMessage || `${item.label} is invalid`;
						}
					}
				}
			}
		});

		setValidationErrors(errors);
		return Object.keys(errors).length === 0;
	}

	const handleBackBtnClick = () => {
		const lastPage = chartData.listPage;
		if (lastPage) {
			props.history.push({ pathname: `/${props.match.params.appid}/page/${lastPage}` });
		} else {
			history.goBack()
		}
	}

	const onSaveClick = () => {
		// Validate all fields before saving
		if (!validateAllFields()) {
			toast.error('Please fix validation errors before saving', { autoClose: 3000 });
			return;
		}

		// let data = JSON.parse(JSON.stringify(state))
		let data = Object.assign({}, state)
		console.log("onSaveClick === data", data);
		selectedDataElements.forEach(sd => {
			console.log("onSaveClick === sd", sd);
			if ((sd.hide || sd.readonly) && sd.defaultValue) {
				data[sd.value] = sd.defaultValue
			}
			if (sd.type === "number" && data[sd.value]) {
				data[sd.value] = parseInt(data[sd.value])
			}
		})
		console.log("onSaveClick === final data", data);

		let formData = {
			appid: props.match.params.appid,
			dataModelId: chartData?.selectedDataModel,
			payload: data
		}
		if (_id) {
			formData['dataUniqueId'] = chartUniqueId + '_update'
			props.updateDataModelData(formData)
		} else {
			formData['dataUniqueId'] = chartUniqueId + '_save'
			if(chartData?.isObligationEnable && chartData?.isObligationEnable === true)
			{
				props.createObligationsDocument(formData)
			}
			else
			{
				props.createDocument(formData)
			}
			
		}
	}

	const getValue = (key) => {
		let value = { value: state[key], label: state[key] }
		if (value && (value.value === null || value.value === undefined)) {
			value.value = '';
		}
		if (value && (value.label === null || value.label === undefined)) {
			value.label = '';
		}
		return value
	}

	const getOptions = (de) => {
		let options = []
		if (de.data?.type === 'custom') {
			if (de.data?.options?.length > 0) {
				options = de.data.options.map(option => {
					return {
						value: option?.value?.toString(),
						label: option?.label?.toString()
					}
				})
			}
		}
		else if (de.data?.type === 'commonMasterDataConfiguration') {
			options = props.formData?.document[de.data.commonMasterDataConfigurationId]?.data.map((resd) => {
				return {
					value: resd?.languageLocale?.toString(),
					label: resd?.languageLocale?.toString()
				}
			})
		}
		return options;
	}

	const payloadForUploadSupportingDocument = (files, key, templateId, dataModelId) => {
		let formData = new FormData();
		formData.append('file', files)
		formData.append('dataElement', key)
		return {
			formData,
			appId: props.match.params.appid,
			dataModelId,
			templateId,
			dataUniqueId: chartUniqueId + "_upload_Amendment_Template"
		}
	}

	const handleFileChange = (event, key) => {
		const file = event.target.files[0];
		if (file && file.name.endsWith(".doc") || file.name.endsWith(".docx")) {
			setSelectedFile({ ...selectedFile, [key]: file });
			setFile(file);
		}
		event.target.value = "";
	};

	const handleRemoveFile = (val, val1) => {
		if (val === "already") {
			setState(prevState => {
				const newState = { ...prevState };
				Object.keys(newState).forEach(key => {
					if (newState[val1]) {
						newState[val1] = ""; // Remove the key if it has the value "val1"
					}
				});
				return newState;
			});
		}
		else if (val == "new") {
			if (val1) {
				// Remove specific file from selectedFile
				setSelectedFile(prevSelectedFile => {
					const newSelectedFile = { ...prevSelectedFile };
					delete newSelectedFile[val1];
					return Object.keys(newSelectedFile).length > 0 ? newSelectedFile : null;
				});
			} else {
				// Remove all files (backward compatibility)
				setSelectedFile(null);
				setFile(null);
				setFileURL(null);
			}
		}
		//onChangeField(item.value, null); // Reset file
	};

	if (Helpers.loading(props, '_get')) {
		return <Loader />
	}


	const selectFields = selectedDataElements.filter(item => {
		if (item?.hide) return false
		let de = allDataElementsObj[item.value]
		return de?.type === 'select' || de?.data?.type === "custom"
	})
	
	const fileFields = selectedDataElements.filter(item => {
		if (item?.hide) return false
		let de = allDataElementsObj[item.value]
		return de?.type === "file"
	})

	const selectFilePairs = []
	const maxPairs = Math.max(selectFields.length, fileFields.length)
	for (let i = 0; i < maxPairs; i++) {
		selectFilePairs.push({
			select: selectFields[i] || null,
			file: fileFields[i] || null
		})
	}

	return (
		isAccessControl.error || (!userHasAbility && ability && Object.keys(ability).length === 0) ? <Typography variant="h6" style={{ color: 'red', textAlign: 'center', display: "flex", justifyContent: "center", alignItems: "center" }}>
			{isAccessControl.message ? isAccessControl.message : "You don't have enough permissions to access this page."}
		</Typography> :
		<div>
		{!isNewV1Theme ? (
					// old design
			<div className={classes.divContainer}>
				<div className={classes.divHeader}>
					<div style={{ display: 'flex' }} >
						<IconButton onClick={handleBackBtnClick} className={classes.backIconCls} title={'Back'}>
							<ArrowBackIosIcon />
						</IconButton>
						<h1>{props.page.title}</h1>
					</div>
					{/*  Checking the CREATE EDIT for the user to show the ADD / Update Button using the Can component using Previlages */}
					{userHasAbility ?
						canAny(ability, [EDIT, CREATE, ALL], 'Resource') &&
						<div>
							<Button
								color="primary"
								onClick={onSaveClick}
								style={{ textTransform: 'capitalize' }}
								variant="contained"
							>
								{
									(Helpers.loading(props, '_save') || Helpers.loading(props, '_update')) ? <CircularProgress color='#fff' size={24} /> : (_id ? "Update" : "Add")
								}
							</Button>
						</div>
						: null}
				</div>
				<Divider />

				<Grid xs={12} spacing={2} container style={{ padding: "20px 5px 0px 0px", position: 'relative', overflow: 'visible' }}>
					{selectedDataElements.filter(item => !item?.hide).map((item, sdeIndex) => {
						let de = allDataElementsObj[item.value]
						let type = de?.type || 'string'
						if (dataElementTypes.indexOf(type) !== -1) {
							return (
								<React.Fragment key={sdeIndex}>
									<Grid className={classes.gridStyle1} style={{marginLeft: 20}} item xs={2} sm={2} md={1}>
										<InputLabel
											htmlFor="my-input"
											className={classes.InputLabel}
											id={`${item.value}_label_${sdeIndex}`}
										>
											{item.label}
										</InputLabel>
										<IconButton id={`${item.value}_add-new-box`} onClick={() => handleAddTextbox(item.value, type)}>
											<AddCircleOutlineIcon />
										</IconButton>
									</Grid>
									<Grid item xs={4} sm={4} md={3}>
										{Array.isArray(state?.[item.value]) &&
											state?.[item.value]?.length > 0 ? (
												state?.[item.value]?.map((fieldValue, index) => {
													const errorKey = `${item.value}_${index}`;
													const hasError = !!validationErrors[errorKey];
													return (
														<Box key={index} className={classes.gridStyle2}>
															<TextField
																id={`${item.value}_${sdeIndex}_${index}`}
																name={`multiple-${item.value}`}
																variant="outlined"
																disabled={item?.readonly}
																className={classes.TextField}
																value={fieldValue}
																placeholder={'Enter ' + item.label}
																error={hasError}
																helperText={hasError ? validationErrors[errorKey] : ''}
																onChange={e =>
																	onChangeField(item.value, e.target.value, type, index)
																}
															/>
													{Array.isArray(state?.[item.value]) && state?.[item.value]?.length > 0 && state?.[item.value]?.length !== 1 && (
														<IconButton
															id={`${item.value}_delete_${index}`}
															onClick={() => handleDeleteTextbox(item.value, index)}
														>
															<DeleteIcon />
														</IconButton>
													)}
												</Box>
													);
												})
										) : (
											<TextField
												id={`${item.value}_${sdeIndex}`}
												name={`multiple-${item.value}`}
												variant="outlined"
												disabled={item?.readonly}
												className={classes.TextField}
												value={state?.[item.value] || ''}
												placeholder={'Enter ' + item.label}
												error={!!validationErrors[item.value]}
												helperText={validationErrors[item.value] || ''}
												onChange={e =>
													onChangeField(item.value, e.target.value, type)
												}
											/>
										)
										}
									</Grid>
								</React.Fragment>
							);
						}
						return (
							<React.Fragment>
								<Grid className={classes.gridStyle1} item xs={2} sm={2} md={2}>
									<InputLabel
										htmlFor="my-input"
										className={isViewOnly(ability, 'Resource') ? "" : classes.InputLabel}
										id={`${item.value}_selectLabel_${sdeIndex}`}
									>
										{item.label}
									</InputLabel>
								</Grid>
								<Grid item xs={4} sm={2} md={4}>
									{(type === 'select' || de?.data?.type === "custom") ? (
										isViewOnly(ability, 'Resource') ? (
											<Box>
												<Typography className={classes.InputLabel} variant="body2">
													{getValue(item.value)?.label || '-'}
												</Typography>
											</Box>
										) : (
											<ChipSelect
												id={`${item.value}_${sdeIndex}`}
												label=''
												isSearchable
												placeholder=''
												isClearable={true}
												menuPlacement='top'
												options={getOptions(de)}
												isDisabled={item.readonly}
												value={getValue(item.value)}
												// className={classes.chipSelect}
												className={classes.TextField}
												textFieldProps={{
													InputLabelProps: {
														shrink: true
													},
													variant: "outlined",
													disabled: item.readonly
												}}
												variant={'fixed'}
												onChange={(v) => onChangeField(item.value, v?.value)}
												qapage={true}
											/>
										)
									) : type === "file" ? (
										// <input type="file" />

										isViewOnly(ability, 'Resource') ? (
											state[item.value]?.originalName ? (
												<Box style={{ display: "flex", alignItems: "center", marginTop: 8 }}>
													<Typography variant="body2" className={classes.InputLabel}>
														{state[item.value]?.originalName}
													</Typography>
													<IconButton size="small" onClick={handlesQuickPDFOpen}>
														<VisibilityIcon color="primary" />
													</IconButton>
												</Box>
											) : (
												<Typography variant="body2">No file uploaded</Typography>
											)
										) : (
											<>
												<input
													style={{ display: 'none' }} // Hide default file input
													id={`${item.value}_${sdeIndex}`}
													accept=".doc,.docx"
													type="file"
													disabled={item.readonly}
													onChange={(e) => { handleFileChange(e, item.value) }}
												/>
												{
													(!state[item.value] && !selectedFile?.[item.value]?.name) ? <label htmlFor={`${item.value}_${sdeIndex}`}>
														<CloudUploadIcon color="primary" style={{ fontSize: "30px", cursor: "pointer" }} />
													</label> : null
												}
												{
													state[item.value] && !selectedFile?.[item.value]?.name && (
														<div style={{ display: "flex", alignItems: "center", marginTop: 8 }}>
															<Typography variant="body2" style={{ marginRight: 8 }}>
																{state[item.value].originalName}
															</Typography>
															<IconButton size="small" onClick={() => { handleRemoveFile('already', item.value) }}>
																<DeleteIcon color="error" />
															</IconButton>
															<IconButton size="small" onClick={handlesQuickPDFOpen}>
																<VisibilityIcon color="primary" />
															</IconButton>
															<IconButton size="small" onClick={handlesQuickDownload}>
																<GetAppIcon color="primary" />
															</IconButton>
														</div>
													)
												}

												{selectedFile && selectedFile?.[item.value]?.name && !state[item.value] &&
													<div style={{ display: "flex", alignItems: "center", marginTop: 8 }}>
														<Typography variant="body2" style={{ marginRight: 8 }}>
															{selectedFile?.[item.value]?.name}
														</Typography>
														<IconButton size="small" onClick={() => { handleRemoveFile('new') }}>
															<DeleteIcon color="error" />
														</IconButton>
														{state[item.value] && state[item.value]?.fileName ? <IconButton size="small" onClick={handlesQuickPDFOpen}>
															<VisibilityIcon color="primary" />
														</IconButton> : null}
													</div>
												}
											</>
										)
									)
										: (
											isViewOnly(ability, 'Resource') ?
												<Typography className={classes.InputLabel} variant="body2">
													{state[item.value]}
												</Typography>
												:
												<TextField
													id={`${item.value}_${sdeIndex}`}
													name={item.value}
													variant="outlined"
													type={type === "currency" ? "number" : type}
													disabled={item.readonly}
													className={classes.TextField}

													value={state[item.value]}
													placeholder={'Enter ' + item.label}
													error={!!validationErrors[item.value]}
													helperText={validationErrors[item.value] || ''}
													onChange={(e) => onChangeField(item.value, e.target.value)}
												/>
										)}
								</Grid>
							</React.Fragment>
						)
					})}
				</Grid>
				{/* <div
                dangerouslySetInnerHTML={{ __html: htmlContent }}
            /> */}
				{
					quickPdfView && <ShowFileUploadModel
						{...props}
						open={quickPdfView}
						formData={props.formData}
						appId={props.match.params.appid}
						dataModelId={chartData.selectedDataModel}
						templateId={_id}
						handlesQuickPDFClose={handlesQuickPDFClose}
					/>
				}
					</div>
		) : (
			// new design
			<div >
				{/* Header */}
				<div className={classes.newDesignHeader}>
					<IconButton onClick={handleBackBtnClick} className={classes.backIconCls} title={'Back'}>
						< ArrowBackIcon style={{color: "#000"}}/>
					</IconButton>
					{_id ? <h2 style={{fontWeight: 500}}>Edit {props.page.title}</h2> : <h2 style={{fontWeight: 500}}>Add {props.page.title}</h2>}
				</div>

				{/* Content */}
				<div style={{border: "1px solid #e0e0e0", borderRadius: "4px"}}>
					<div className={classes.newDesignContent}>
						{/* Row 1: Name and Description */}
						<div className={classes.newDesignRow}>
							{/* Name field (first field) */}
							<div className={classes.newDesignLeftColumn}>
								{selectedDataElements.filter(item => !item?.hide).slice(0, 1).map((item, sdeIndex) => {
									let de = allDataElementsObj[item.value]
									let type = de?.type || 'string'
									const isArrayType = dataElementTypes.indexOf(type) !== -1
									
									if (isArrayType) {
										const fieldValues = Array.isArray(state?.[item.value]) && state[item.value].length > 0
											? state[item.value]
											: ['']
										
										return (
											<div key={sdeIndex}>
												<div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px'}}>
													<Typography className={classes.lables}>{item.label}</Typography>
													{!isViewOnly(ability, 'Resource') && (
														<IconButton 
															id={`${item.value}_add-new-box`} 
															onClick={() => handleAddTextbox(item.value, type)}
														>
															<AddCircleOutlineIcon />
														</IconButton>
													)}
												</div>
												{isViewOnly(ability, 'Resource') ? (
													<div>
														{fieldValues.map((val, idx) => (
															<Typography key={idx} variant="body2" style={{ paddingTop: '8px', marginBottom: '12px' }}>
																{val || '-'}
															</Typography>
														))}
													</div>
												) : (
													<>
															{fieldValues.map((fieldValue, index) => {
																const errorKey = `${item.value}_${index}`;
																const hasError = !!validationErrors[errorKey];
																return (
																	<div key={index} className={classes.alternateVendorRow}>
																		<TextField
																			id={`${item.value}_${sdeIndex}_${index}`}
																			name={`${item.value}_${index}`}
																			variant="outlined"
																			fullWidth
																			placeholder="Name"
																			disabled={item?.readonly}
																			className={classes.textField}
																			value={fieldValue}
																			error={hasError}
																			helperText={hasError ? validationErrors[errorKey] : ''}
																			onChange={(e) => onChangeField(item.value, e.target.value, type, index)}
																		/>
																{fieldValues.length > 1 && (
																	<IconButton
																		size="small"
																		onClick={() => handleDeleteTextbox(item.value, index)}
																		className={classes.deleteIcon}
																	>
																		<DeleteOutlineOutlinedIcon />
																	</IconButton>
																)}
															</div>
																);
															})}
													</>
												)}
											</div>
										)
									}
									
									return (
										<div key={sdeIndex}>
											<Typography className={classes.lables}>{item.label}</Typography>
											{isViewOnly(ability, 'Resource') ? (
												<Typography variant="body2" >
													{state[item.value] || '-'}
												</Typography>
											) : (
												<TextField
													id={`${item.value}_${sdeIndex}`}
													name={item.value}
													variant="outlined"
													fullWidth
													placeholder="Name"
													disabled={item?.readonly}
													className={classes.textField}
													value={state[item.value] || ''}
														error={!!validationErrors[item.value]}
														helperText={validationErrors[item.value] || ''}
													onChange={(e) => onChangeField(item.value, e.target.value)}
												/>
											)}
										</div>
									)
								})}
							</div>

							{/* Description field (second field) */}
							<div className={classes.newDesignRightColumn}>
								{selectedDataElements.filter(item => !item?.hide).slice(1, 2).map((item, sdeIndex) => {
									let de = allDataElementsObj[item.value]
									let type = de?.type || 'string'
									const isFileField = type === "file"
									
									if (isFileField) return null // Skip file fields here, handle separately
									
									return (
										<div key={sdeIndex} >
												<Typography className={classes.lables}>{item.label}</Typography>
														
											    {Array.isArray(state?.[item.value]) && state[item.value].length > 0 ? (
												state[item.value].map((fieldValue, index) => {
													const errorKey = `${item.value}_${index}`;
													const hasError = !!validationErrors[errorKey];
													return (
														<Box key={index} className={classes.alternateVendorRow} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
															<TextField
																id={`${item.value}_${sdeIndex}_${index}`}
																name={`multiple-${item.value}`}
																variant="outlined"
																type={type === 'currency' ? 'number' : type}
																fullWidth
																placeholder={'Enter ' + item.label}
																disabled={item?.readonly}
																className={classes.textField}
																value={fieldValue}
																error={hasError}
																helperText={hasError ? validationErrors[errorKey] : ''}
																onChange={(e) => onChangeField(item.value, e.target.value, type, index)}
															/>
																						
													{state[item.value].length > 1 && (
														<IconButton
														size="small"
														onClick={() => handleDeleteTextbox(item.value, index)}
														className={classes.deleteIcon}
														>
														<DeleteOutlineOutlinedIcon />
														</IconButton>
													)}
													</Box>
													);
												})
												
												  ) : (
														<TextField
														id={`${item.value}_${sdeIndex}_0`}
														name={item.value}
														variant="outlined"
														type={type === 'currency' ? 'number' : type}
														fullWidth
														// multiline
														// rows={3}
														placeholder={'Enter ' + item.label}
														disabled={item?.readonly}
														className={classes.textField}
														value={dataElementTypes.indexOf(type) !== -1 ? (state[item.value]?.[0] || '') : (state[item.value] || '')}
														error={!!validationErrors[item.value]}
														helperText={validationErrors[item.value] || ''}
														onChange={(e) => onChangeField(item.value, e.target.value, type, 0)}
														/>
													)}

													{/* Add Icon — Placed After TextFields */}
													{!isViewOnly(ability, 'Resource') && props.page.title === 'Alternate Vendors' && (
														<div style={{ marginTop: 8, display: 'flex', alignItems: 'center' }}>
														<Button
															onClick={() => handleAddTextbox(item.value, type)}
															variant="outlined"
															size="small"
															className={classes.cancel}
														>
															+ Add
														</Button>
														</div>
													)}
													</div>

											);
										})}
										</div>
						</div>

						{/* Row 2: Language and File pairs */}
						{selectFilePairs.map((pair, pairIndex) => (
							<div key={`selectFilePair_${pairIndex}`} className={classes.newDesignRow} style={{paddingTop: pairIndex === 0 ? 0 : 16}}>
								{/* Language field */}
								{pair.select && (
									<div className={classes.newDesignLeftColumn}>
										<Typography className={classes.lables}>{pair.select.label}</Typography>
										{isViewOnly(ability, 'Resource') ? (
											<Typography variant="body2" >
												{getValue(pair.select.value)?.label || '-'}
											</Typography>
										) : (
											<ChipSelect
												id={`${pair.select.value}_lang_${pairIndex}`}
												label=''
												isSearchable
												placeholder='Enter'
												isClearable={true}
												menuPlacement='top'
												options={getOptions(allDataElementsObj[pair.select.value])}
												isDisabled={pair.select.readonly}
												value={getValue(pair.select.value)}
												className={classes.chipSelect}
												textFieldProps={{
													InputLabelProps: { shrink: true },
													variant: "outlined",
													disabled: pair.select.readonly
												}}
												variant={'fixed'}
												onChange={(v) => onChangeField(pair.select.value, v?.value)}
												qapage={true}
											/>
										)}
									</div>
								)}

								{/* File field */}
								{pair.file && (
									<div className={classes.newDesignRightColumn}>
										<Typography className={classes.lables}>{pair.file.label}</Typography>
										{isViewOnly(ability, 'Resource') ? (
											state[pair.file.value]?.originalName ? (
												<Box style={{ display: "flex", alignItems: "center", marginTop: 8 }}>
													<Typography variant="body2">
														{state[pair.file.value]?.originalName}
													</Typography>
													<IconButton size="small" onClick={handlesQuickPDFOpen}>
														<VisibilityOutlinedIcon color="primary" />
													</IconButton>
												</Box>
											) : (
												<Typography variant="body2">No file uploaded</Typography>
											)
										) : (
											<>
												<input
													style={{ display: 'none' }}
													id={`${pair.file.value}_file_${pairIndex}`}
													accept=".doc,.docx"
													type="file"
													disabled={pair.file.readonly}
													onChange={(e) => { handleFileChange(e, pair.file.value) }}
												/>
												{(!state[pair.file.value] && !selectedFile?.[pair.file.value]?.name) && (
													<label htmlFor={`${pair.file.value}_file_${pairIndex}`} style={{ display: 'block' }}>
														<Box className={classes.uploadBox}>
															<AddIcon color="primary" className={classes.uploadIcon} />
															<Typography variant="body2" className={classes.uploadText}>
																Upload
															</Typography>
														</Box>
													</label>
												)}
												{(state[pair.file.value] || selectedFile?.[pair.file.value]?.name) && (
													<div className={classes.uploadedFileContainer}>
														<div className={classes.uploadedFileBox}>
															<IconButton size="small" onClick={handlesQuickPDFOpen}>
																<VisibilityOutlinedIcon color="primary" />
															</IconButton>
															<Typography variant="body2" className={classes.lables} style={{ fontSize: '14px' }}>
																{state[pair.file.value]?.originalName || selectedFile?.[pair.file.value]?.name}
															</Typography>
														</div>
														<IconButton size="small" onClick={() => { handleRemoveFile(state[pair.file.value] ? 'already' : 'new', pair.file.value) }}>
															<DeleteOutlineOutlinedIcon color="error" />
														</IconButton>
													</div>
												)}
											</>
										)}
									</div>
								)}
							</div>
						))}

							{/* Other fields (alternate vendor names, etc.) */}
							<>
								{/* Render array type fields */}
								{arrayFields.map(({ item, index, type }) => {
									const fieldValues = Array.isArray(state?.[item.value]) && state[item.value].length > 0
										? state[item.value]
										: ['']
									
									return (
										<div key={`array_${index}`}>
											<Typography className={classes.lables}>{item.label}</Typography>
											{isViewOnly(ability, 'Resource') ? (
												<div>
													{fieldValues.map((val, idx) => (
														<Typography key={idx} variant="body2" style={{ paddingTop: '8px', marginBottom: '12px' }}>
															{val || '-'}
														</Typography>
													))}
												</div>
											) : (
												<>
														{fieldValues.map((fieldValue, fieldIndex) => {
															const errorKey = `${item.value}_${fieldIndex}`;
															const hasError = !!validationErrors[errorKey];
															return (
																<div key={fieldIndex} className={classes.alternateVendorRow}>
																	<TextField
																		id={`${item.value}_${index}_${fieldIndex}`}
																		name={`${item.value}_${fieldIndex}`}
																		variant="outlined"
																		fullWidth
																		placeholder="Enter"
																		disabled={item?.readonly}
																		className={classes.textField}
																		value={fieldValue}
																		error={hasError}
																		helperText={hasError ? validationErrors[errorKey] : ''}
																		onChange={(e) => onChangeField(item.value, e.target.value, type, fieldIndex)}
																	/>
															{fieldValues.length > 1 && (
																<IconButton
																	size="small"
																	onClick={() => handleDeleteTextbox(item.value, fieldIndex)}
																	className={classes.deleteIcon}
																>
																	<DeleteOutlineOutlinedIcon />
																</IconButton>
															)}
														</div>
															);
														})}
													<Button
														variant="outlined"
														size="small"
														startIcon={<AddCircleOutlineIcon />}
														onClick={() => handleAddTextbox(item.value, type)}
														className={classes.addButton}
														disabled={item?.readonly}
													>
														Add
													</Button>
												</>
											)}
										</div>
									)
								})}

								{/* Render regular text/number fields in pairs */}
								{regularFieldPairs.map((pair, pairIndex) => (
									<div key={`pair_${pairIndex}`} style={{ display: 'flex', gap: '10px', width: '100%' }}>
										{pair.map(({ item, index, type }) => (
											<div key={`regular_${index}`} style={{ width: '50%' }}>
												<Typography className={classes.lables}>{item.label}</Typography>
												{isViewOnly(ability, 'Resource') ? (
													<Typography variant="body2" >
														{state[item.value] || '-'}
													</Typography>
												) : (
													<TextField
														id={`${item.value}_${index}`}
														name={item.value}
														variant="outlined"
														fullWidth
														placeholder="Enter"
														type={type === "currency" ? "number" : type}
														disabled={item?.readonly}
														className={classes.textField}
														value={state[item.value] || ''}
														error={!!validationErrors[item.value]}
														helperText={validationErrors[item.value] || ''}
														onChange={(e) => onChangeField(item.value, e.target.value)}
													/>
												)}
											</div>
										))}
									</div>
								))}
							</>
					</div>
				
					{/* Action Buttons */}
					{userHasAbility && canAny(ability, [EDIT, CREATE, ALL], 'Resource') && (
						<div className={classes.buttonContainer}>
							<Button
								variant="outlined"
								onClick={handleBackBtnClick}
								className={classes.cancel}
							>
								Close
							</Button>
							<Button
								variant="contained"
								onClick={onSaveClick}
								className={classes.update}
								disabled={Helpers.loading(props, '_save') || Helpers.loading(props, '_update')}
							>
								{(Helpers.loading(props, '_save') || Helpers.loading(props, '_update')) ? (
									<CircularProgress color='#fff' size={20} />
								) : (
									_id ? "Update" : "Add"
								)}
							</Button>
						</div>
					)}
				</div>
				{quickPdfView && (
					<ShowFileUploadModel
						{...props}
						open={quickPdfView}
						formData={props.formData}
						appId={props.match.params.appid}
						dataModelId={chartData.selectedDataModel}
						templateId={_id}
						handlesQuickPDFClose={handlesQuickPDFClose}
					/>
				)}
			</div>
		)}
			</div>
	);
};

const mapDispatchToProps = {
    getDataModelById,
    getContractDataById,
    updateDataModelData,
    createDocument,
    getModelData,
    clearReduxDataOfCurrentComponent,
    uploadAttachmentAmendmentTemplate,
    downloadAmendmentTemplateAction,
    downloadAmendmentTemplateActionV2,
    downloadContractPDFAction,
	createObligationsDocument
}

const mapStateToProps = state => {
	return {
		formData: state.form,
	};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SimpleForm))